import { render, staticRenderFns } from "./buttonExtractionIndicators.vue?vue&type=template&id=d10430d0&scoped=true&"
import script from "./buttonExtractionIndicators.vue?vue&type=script&lang=js&"
export * from "./buttonExtractionIndicators.vue?vue&type=script&lang=js&"
import style0 from "./buttonExtractionIndicators.vue?vue&type=style&index=0&id=d10430d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10430d0",
  null
  
)

export default component.exports